import React, { useEffect } from "react";
import GoogleMap from "./GoogleMap";

export default function TrackerSettings({tracker}) {
    const [data, setData] = React.useState({
        speed: false,
        distance: false,
        distanceKm: 5,
        lat: -23.57,
        lng: -46.68,
        points: [
            { lat: 25.774, lng: -80.19 },
            { lat: 18.466, lng: -66.118 },
            { lat: 32.321, lng: -64.757 },
            { lat: 25.774, lng: -80.19 },
        ]
    });

    function updateRadius(value) {
        if (value < 0) {
            value = 0;
        }
        setData({ ...data, radius: value });
    }

    function processNewLocation(lat, lng) {
        const points = [];
        const numberOfPoints = 32; // number of points to create circle
        const radius = data.distanceKm; // use distanceKm from state

        for (let i = 0; i < numberOfPoints; i++) {
            const angle = (i * 2 * Math.PI) / numberOfPoints;
            const dx = radius * Math.cos(angle);
            const dy = radius * Math.sin(angle);

            // Convert km offset to lat/lng
            const newLat = lat + (dy / 111.32); // 111.32 km per degree latitude
            const newLng = lng + (dx / (111.32 * Math.cos(lat * (Math.PI / 180)))); // adjust for longitude

            points.push({ lat: newLat, lng: newLng });
        }

        // Close the circle by adding the first point again
        points.push(points[0]);

        setData({ ...data, lat, lng, points });
    }


    return (
        <div className="">
            <div className="content-heading">
                Configurações do Rastreador
            </div>
            <div className="block block-rounded block-bordered">
                <div className="block-header">
                    <div className="block-title"><i className="far fa-bell text-warning" /> Alerta de velocidade</div>
                    <div className="block-tools">
                        <div class="custom-control custom-switch mb-1">
                            <input type="checkbox" class="custom-control-input" id="example-sw-custom1" name="example-sw-custom1" onClick={() => setData({ ...data, speed: !data.speed })} />
                            <label class="custom-control-label" for="example-sw-custom1">Habilitar</label>
                        </div>
                    </div>
                </div>
                {data.speed && (
                    <div className="block-content">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="font-w700">
                                    Velocidade máxima
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button className="btn btn-sm btn-dual">
                                                <i className="si si-arrow-left" />
                                            </button>
                                        </div>
                                        <input type="number" class="form-control form-control-alt text-center" placeholder="00" />
                                        <div class="input-group-append">
                                            <button className="btn btn-sm btn-dual">
                                                <i className="si si-arrow-right" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="block block-rounded block-bordered">
                <div className="block-header">
                    <div className="block-title"><i className="far fa-map text-warning" /> Configurar cerca geográfica</div>
                    <div className="block-tools">
                        <div class="custom-control custom-switch mb-1">
                            <input type="checkbox" class="custom-control-input" id="distance" name="distance" onClick={() => setData({ ...data, distance: !data.distance })} />
                            <label class="custom-control-label" for="distance">Habilitar</label>
                        </div>
                    </div>
                </div>
                {data.distance && (
                    <div className="block-content">
                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <GoogleMap
                                    defaultZoom={9}
                                    defaultCenter={data}
                                    bootstrapURLKeys={{
                                        key: "AIzaSyDN3UVIMYb0l_DCSkM6DwSnD6Ow3prkWZI",
                                        libraries: ["visualization", "drawing"],
                                    }}
                                    onClick={(e) => processNewLocation(e.lat, e.lng)}
                                >
                                    {data && data.points && data.points.map((point, index) => (
                                        <div className="marker" lat={point.lat} lng={point.lng} key={index}>
                                            <i className="fas fa-map-marker-alt text-danger" />
                                        </div>
                                    ))}
                                </GoogleMap>
                            </div>
                            <div className="col-md-6">
                                <div className="font-w700">
                                    Distância máxima (KM)
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <button className="btn btn-sm btn-dual">
                                                <i className="si si-arrow-left" />
                                            </button>
                                        </div>
                                        <input
                                            type="number"
                                            className="form-control form-control-alt text-center"
                                            placeholder="0"
                                            onChange={(e) => updateRadius(e.target.value)}
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-sm btn-dual">
                                                <i className="si si-arrow-right" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    )
}